import $ from 'jquery';
import app from './app';
import Router from './router';
import AdminRouter from './router_admin';
import AuthRouter from './router_auth';
import ErrorRouter from './router_errors';
import PublicRouter from './router_public';
import { initiateOAuthFlow } from './auth/oauth';

require('bootstrap');
require('./analytics');
require('./tailwind.config');

// Suppress ResizeObserver errors in development
if (process.env.NODE_ENV === 'development') {
  const resizeObserverErrorHandler = (e: ErrorEvent) => {
    if (
      e.message === 'ResizeObserver loop limit exceeded' ||
      e.message.includes(
        'ResizeObserver loop completed with undelivered notifications'
      )
    ) {
      e.stopImmediatePropagation();
      return false;
    }
    return true;
  };

  window.addEventListener('error', resizeObserverErrorHandler);
  window.addEventListener('unhandledrejection', (e) => {
    if (
      e.reason &&
      e.reason.message &&
      e.reason.message.includes('ResizeObserver')
    ) {
      e.preventDefault();
    }
  });
}

$(document).ready(() => {
  app.on('before:start', () => {
    app.router_errors = new ErrorRouter();
    app.router_auth = new AuthRouter();
    app.router_public_pages = new PublicRouter();
    app.router = new Router();
    app.router_admin = new AdminRouter();
  });

  const { pathname } = window.location;
  const isOAuthCallback = pathname === '/oauth/callback';
  const isRedirectingToOAuth =
    sessionStorage.getItem('oauth_redirecting') === 'true';

  // OAuth callback - let AuthRouter handle it
  if (isOAuthCallback) {
    app.start();
    return;
  }

  // If redirecting to OAuth, don't check auth (redirect in progress)
  if (isRedirectingToOAuth) {
    return;
  }

  // Protected routes - check authentication using existing session model
  app.session
    .check_auth()
    .then(() => {
      app.start();
    })
    .catch(() => {
      // Not authenticated - redirect to OAuth
      const currentPath = window.location.pathname + window.location.search;
      if (currentPath.length > 1 && currentPath !== '/') {
        sessionStorage.setItem('oauth_redirect', currentPath);
      }
      initiateOAuthFlow();
    });
});
